import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './ToolGroupOverlay.scss';

const ToolGroupOverlay = ({ overlayLayout, ...props }) => (
  <div id="qau-tool-group-overlay" className={classnames({ active: !!overlayLayout })} {...props}>
    {overlayLayout}
  </div>
);

ToolGroupOverlay.propTypes = {
  overlayLayout: PropTypes.node,
};

export default ToolGroupOverlay;
